module.exports = __webpack_public_path__ + "img/undraw-website_setup.36f3de98.png";